import React, { Fragment, useState, useEffect } from "react";
import Skeleton from "react-loading-skeleton";
import { v4 as uuidv4 } from "uuid";
import List from "../list/List";

import Utils from "../../utils/Utils";

const BracketRound = ({ children, ColumnRound }) => {
  return <ul className={`round round-${ColumnRound}`}>{children}</ul>;
};

const BracketWrapper = ({ children }) => {
  return <div id="tournament">{children}</div>;
};

const getImage = (team, winner = false) => {
  if (!team && winner) return "TBD Tonight";
  if (!team) return "TBD";
  return <img src={`/static/media/logos/${team}.png`} alt="team logo" />;
};

const BracketData = ({ data = {}, direction, teamIndex, rankIndex1 = 0, rankIndex2 = 0, isLoading = true }) => {
  const handleModalClick = () => {
    console.log("====================================");
    console.log("redirect");
    console.log("====================================");
  };

  return isLoading === true ? (
    <Fragment>
      <li className={`game position-relative mb-1 ${direction}`}>
        <Skeleton height="40px" width="100px" />
      </li>
      <li className={`game mt-1 position-relative ${direction}`}>
        <Skeleton height="40px" width="100px" />
      </li>
    </Fragment>
  ) : (
    <Fragment>
      <li
        className={`game game-top winner position-relative ${direction}`}
        title="Click for more info"
        onClick={handleModalClick}
      >
        {rankIndex1 !== 0 ? <span className="rankIndex">{data?.["Winner Seed"]}</span> : null}
        <span className="teamName">{data?.["Winner"]}</span>
        {rankIndex1 !== 0
          ? // <img src={`/static/media/logos/${data?.["Winner"]}.png`} />
            getImage(data?.["Winner"])
          : // <img src={`/static/media/logos/${data?.["Team 1"]}.png`} />
            getImage(data?.["Team 1"])}
      </li>
      <li className={`game game-spacer ${direction === "left" ? "right-border" : "left-border"}`}>&nbsp;</li>
      <li
        className={`game game-bottom position-relative ${direction}`}
        title="Click for more info"
        onClick={handleModalClick}
      >
        {rankIndex2 !== 0 ? (
          <span className="rankIndex">
            {data?.["Winner"] === data?.["Team 1"] ? data?.["Team 2 Seed"] : data?.["Team 1 Seed"]}
          </span>
        ) : null}
        <span className="teamName">
          {data?.["Winner"] === data?.["Team 1"] ? (
            <>
              {data?.["Team 2"]} {data?.["Team 3"] && <>/ {data?.["Team 3"]}</>}{" "}
            </>
          ) : (
            data?.["Team 1"]
          )}
        </span>

        {rankIndex1 !== 0
          ? // <img
            //   src={`/static/media/logos/${
            //     data?.["Winner"] === data?.["Team 1"] ? data?.["Team 2"] : data?.["Team 1"]
            //   }.png`}
            // />
            getImage(data?.["Winner"] === data?.["Team 1"] ? data?.["Team 2"] : data?.["Team 1"])
          : // <img src={`/static/media/logos/${data?.["Team 2"]}.png`} />
            getImage(data?.["Team 2"])}
      </li>
    </Fragment>
  );
};

const BracketBlockLeft = ({ data, isLoading = true }) => {
  const onBlockClick = () => {
    console.log("111");
  };
  return (
    <BracketWrapper>
      <BracketRound ColumnRound={1}>
        <Spacer></Spacer>
        <BracketData
          direction="left"
          rankIndex1={1}
          rankIndex2={16}
          data={data?.[0]}
          // data={data?.find((dt) => dt["index"] === 0)}
          onBlockClick={onBlockClick}
          isLoading={isLoading}
        ></BracketData>
        <Spacer></Spacer>
        <BracketData
          direction="left"
          rankIndex1={8}
          rankIndex2={9}
          data={data?.[1]}
          // data={data?.find((dt) => dt["index"] === 1)}
          onBlockClick={onBlockClick}
          isLoading={isLoading}
        ></BracketData>
        <Spacer></Spacer>
        <BracketData
          direction="left"
          rankIndex1={5}
          rankIndex2={12}
          data={data?.[2]}
          // data={data?.find((dt) => dt["index"] === 3)}
          onBlockClick={onBlockClick}
          isLoading={isLoading}
        ></BracketData>
        <Spacer></Spacer>
        <BracketData
          direction="left"
          rankIndex1={4}
          rankIndex2={13}
          data={data?.[3]}
          // data={data?.find((dt) => dt["index"] === 2)}
          onBlockClick={onBlockClick}
          isLoading={isLoading}
        ></BracketData>
        <Spacer></Spacer>
        <BracketData
          direction="left"
          rankIndex1={6}
          rankIndex2={11}
          data={data?.[4]}
          // data={data?.find((dt) => dt["index"] === 5)}
          onBlockClick={onBlockClick}
          isLoading={isLoading}
        ></BracketData>
        <Spacer></Spacer>
        <BracketData
          direction="left"
          rankIndex1={3}
          rankIndex2={14}
          data={data?.[5]}
          // data={data?.find((dt) => dt["index"] === 4)}
          onBlockClick={onBlockClick}
          isLoading={isLoading}
        ></BracketData>
        <Spacer></Spacer>
        <BracketData
          direction="left"
          rankIndex1={7}
          rankIndex2={10}
          data={data?.[7]}
          // data={data?.find((dt) => dt["index"] === 7)}
          onBlockClick={onBlockClick}
          isLoading={isLoading}
        ></BracketData>
        <Spacer></Spacer>
        <BracketData
          direction="left"
          rankIndex1={2}
          rankIndex2={15}
          data={data?.[6]}
          // data={data?.find((dt) => dt["index"] === 6)}
          onBlockClick={onBlockClick}
          isLoading={isLoading}
        ></BracketData>
        <Spacer></Spacer>
      </BracketRound>
      <BracketRound ColumnRound={2}>
        <Spacer></Spacer>
        <BracketData
          teamA="Team 06"
          teamB="Team 11"
          direction="left"
          data={data?.[9]}
          onBlockClick={onBlockClick}
          isLoading={isLoading}
        ></BracketData>
        <Spacer></Spacer>
        <BracketData
          teamA="Team 03"
          teamB="Team 14"
          direction="left"
          data={data?.[8]}
          onBlockClick={onBlockClick}
          isLoading={isLoading}
        ></BracketData>
        <Spacer></Spacer>
        <BracketData
          teamA="Team 07"
          teamB="Team 10"
          direction="left"
          data={data?.[11]}
          onBlockClick={onBlockClick}
          isLoading={isLoading}
        ></BracketData>
        <Spacer></Spacer>
        <BracketData
          teamA="Team 02"
          teamB="Team 15"
          direction="left"
          data={data?.[10]}
          onBlockClick={onBlockClick}
          isLoading={isLoading}
        ></BracketData>
        <Spacer></Spacer>
      </BracketRound>
      <BracketRound ColumnRound={3}>
        {/* Round 3 */}
        <Spacer></Spacer>
        <BracketData
          teamA="Team 06"
          teamB="Team 11"
          direction="left"
          data={data?.[13]}
          onBlockClick={onBlockClick}
          isLoading={isLoading}
        ></BracketData>
        <Spacer></Spacer>
        <BracketData
          teamA="Team 03"
          teamB="Team 14"
          direction="left"
          data={data?.[12]}
          onBlockClick={onBlockClick}
          isLoading={isLoading}
        ></BracketData>
        <Spacer></Spacer>
      </BracketRound>
      {/* Round 4 */}
      <BracketRound ColumnRound={4}>
        <Spacer></Spacer>
        <BracketData direction="left" data={data?.[14]} onBlockClick={onBlockClick} isLoading={isLoading}></BracketData>
        <Spacer></Spacer>
      </BracketRound>
    </BracketWrapper>
  );
};
const BracketBlockLeftEast = ({ data, isLoading = true }) => {
  const onBlockClick = () => {
    console.log("111");
  };
  return (
    <BracketWrapper>
      <BracketRound ColumnRound={1}>
        <Spacer></Spacer>
        <BracketData
          direction="left"
          rankIndex1={1}
          rankIndex2={16}
          data={data?.[0]}
          onBlockClick={onBlockClick}
          isLoading={isLoading}
        ></BracketData>
        <Spacer></Spacer>
        <BracketData
          direction="left"
          rankIndex1={8}
          rankIndex2={9}
          data={data?.[1]}
          onBlockClick={onBlockClick}
          isLoading={isLoading}
        ></BracketData>
        <Spacer></Spacer>
        <BracketData
          direction="left"
          rankIndex1={5}
          rankIndex2={12}
          data={data?.[2]}
          onBlockClick={onBlockClick}
          isLoading={isLoading}
        ></BracketData>
        <Spacer></Spacer>
        <BracketData
          direction="left"
          rankIndex1={4}
          rankIndex2={13}
          data={data?.[3]}
          onBlockClick={onBlockClick}
          isLoading={isLoading}
        ></BracketData>
        <Spacer></Spacer>
        <BracketData
          direction="left"
          rankIndex1={6}
          rankIndex2={11}
          data={data?.[4]}
          onBlockClick={onBlockClick}
          isLoading={isLoading}
        ></BracketData>
        <Spacer></Spacer>
        <BracketData
          direction="left"
          rankIndex1={3}
          rankIndex2={14}
          data={data?.[5]}
          onBlockClick={onBlockClick}
          isLoading={isLoading}
        ></BracketData>
        <Spacer></Spacer>
        <BracketData
          direction="left"
          rankIndex1={7}
          rankIndex2={10}
          data={data?.[7]}
          onBlockClick={onBlockClick}
          isLoading={isLoading}
        ></BracketData>
        <Spacer></Spacer>
        <BracketData
          direction="left"
          rankIndex1={2}
          rankIndex2={15}
          data={data?.[6]}
          onBlockClick={onBlockClick}
          isLoading={isLoading}
        ></BracketData>
        <Spacer></Spacer>
      </BracketRound>
      <BracketRound ColumnRound={2}>
        <Spacer></Spacer>
        <BracketData
          teamA="Team 06"
          teamB="Team 11"
          direction="left"
          data={data?.[8]}
          onBlockClick={onBlockClick}
          isLoading={isLoading}
        ></BracketData>
        <Spacer></Spacer>
        <BracketData
          teamA="Team 03"
          teamB="Team 14"
          direction="left"
          data={data?.[9]}
          onBlockClick={onBlockClick}
          isLoading={isLoading}
        ></BracketData>
        <Spacer></Spacer>
        <BracketData
          teamA="Team 07"
          teamB="Team 10"
          direction="left"
          data={data?.[10]}
          onBlockClick={onBlockClick}
          isLoading={isLoading}
        ></BracketData>
        <Spacer></Spacer>
        <BracketData
          teamA="Team 02"
          teamB="Team 15"
          direction="left"
          data={data?.[11]}
          onBlockClick={onBlockClick}
          isLoading={isLoading}
        ></BracketData>
        <Spacer></Spacer>
      </BracketRound>
      <BracketRound ColumnRound={3}>
        {/* Round 3 */}
        <Spacer></Spacer>
        <BracketData
          teamA="Team 06"
          teamB="Team 11"
          direction="left"
          data={data?.[13]}
          onBlockClick={onBlockClick}
          isLoading={isLoading}
        ></BracketData>
        <Spacer></Spacer>
        <BracketData
          teamA="Team 03"
          teamB="Team 14"
          direction="left"
          data={data?.[12]}
          onBlockClick={onBlockClick}
          isLoading={isLoading}
        ></BracketData>
        <Spacer></Spacer>
      </BracketRound>
      {/* Round 4 */}
      <BracketRound ColumnRound={4}>
        <Spacer></Spacer>
        <BracketData direction="left" data={data?.[14]} onBlockClick={onBlockClick} isLoading={isLoading}></BracketData>
        <Spacer></Spacer>
      </BracketRound>
    </BracketWrapper>
  );
};

const BracketBlockRight = ({ data, isLoading }) => {
  const onBlockClick = () => {
    console.log("111");
  };
  return (
    <BracketWrapper>
      {/* Round 4 */}
      <BracketRound ColumnRound={4} key={uuidv4()}>
        <Spacer></Spacer>
        <BracketData
          key={uuidv4()}
          direction="right"
          data={data?.[14]}
          onBlockClick={onBlockClick}
          isLoading={isLoading}
        ></BracketData>
        <Spacer></Spacer>
      </BracketRound>

      <BracketRound ColumnRound={3} key={uuidv4()}>
        {/* Round 3 */}
        <Spacer></Spacer>
        <BracketData
          teamA="Team 06"
          teamB="Team 11"
          key={uuidv4()}
          direction="right"
          data={data?.[12]}
          onBlockClick={onBlockClick}
          isLoading={isLoading}
        ></BracketData>
        <Spacer></Spacer>
        <BracketData
          teamA="Team 03"
          teamB="Team 14"
          key={uuidv4()}
          direction="right"
          data={data?.[13]}
          onBlockClick={onBlockClick}
          isLoading={isLoading}
        ></BracketData>
        <Spacer></Spacer>
      </BracketRound>

      <BracketRound ColumnRound={2} key={uuidv4()}>
        <Spacer></Spacer>
        <BracketData
          teamA="Team 06"
          teamB="Team 11"
          key={uuidv4()}
          direction="right"
          data={data?.[9]}
          onBlockClick={onBlockClick}
          isLoading={isLoading}
        ></BracketData>
        <Spacer></Spacer>
        <BracketData
          teamA="Team 03"
          teamB="Team 14"
          key={uuidv4()}
          direction="right"
          data={data?.[8]}
          onBlockClick={onBlockClick}
          isLoading={isLoading}
        ></BracketData>
        <Spacer></Spacer>
        <BracketData
          teamA="Team 07"
          teamB="Team 10"
          key={uuidv4()}
          direction="right"
          data={data?.[11]}
          onBlockClick={onBlockClick}
          isLoading={isLoading}
        ></BracketData>
        <Spacer></Spacer>
        <BracketData
          teamA="Team 02"
          teamB="Team 15"
          key={uuidv4()}
          direction="right"
          data={data?.[10]}
          onBlockClick={onBlockClick}
          isLoading={isLoading}
        ></BracketData>
        <Spacer></Spacer>
      </BracketRound>

      <BracketRound ColumnRound={1} key={uuidv4()}>
        <Spacer></Spacer>
        <BracketData
          teamA="Team 01"
          teamB="Team 16"
          key={uuidv4()}
          direction="right"
          rankIndex1={1}
          rankIndex2={16}
          data={data?.[0]}
          onBlockClick={onBlockClick}
          isLoading={isLoading}
        ></BracketData>
        <Spacer></Spacer>
        <BracketData
          teamA="Team 08"
          teamB="Team 09"
          key={uuidv4()}
          direction="right"
          rankIndex1={8}
          rankIndex2={9}
          data={data?.[1]}
          onBlockClick={onBlockClick}
          isLoading={isLoading}
        ></BracketData>
        <Spacer></Spacer>
        <BracketData
          teamA="Team 05"
          teamB="Team 12"
          key={uuidv4()}
          direction="right"
          rankIndex1={5}
          rankIndex2={12}
          data={data?.[2]}
          onBlockClick={onBlockClick}
          isLoading={isLoading}
        ></BracketData>
        <Spacer></Spacer>
        <BracketData
          teamA="Team 04"
          teamB="Team 13"
          key={uuidv4()}
          direction="right"
          rankIndex1={4}
          rankIndex2={13}
          data={data?.[3]}
          onBlockClick={onBlockClick}
          isLoading={isLoading}
        ></BracketData>
        <Spacer></Spacer>
        <BracketData
          teamA="Team 06"
          teamB="Team 11"
          key={uuidv4()}
          direction="right"
          rankIndex1={6}
          rankIndex2={11}
          data={data?.[5]}
          onBlockClick={onBlockClick}
          isLoading={isLoading}
        ></BracketData>
        <Spacer></Spacer>
        <BracketData
          teamA="Team 03"
          teamB="Team 14"
          key={uuidv4()}
          direction="right"
          rankIndex1={3}
          rankIndex2={14}
          data={data?.[4]}
          onBlockClick={onBlockClick}
          isLoading={isLoading}
        ></BracketData>
        <Spacer></Spacer>
        <BracketData
          teamA="Team 07"
          teamB="Team 10"
          key={uuidv4()}
          direction="right"
          rankIndex1={7}
          rankIndex2={10}
          data={data?.[7]}
          onBlockClick={onBlockClick}
          isLoading={isLoading}
        ></BracketData>
        <Spacer></Spacer>
        <BracketData
          teamA="Team 02"
          teamB="Team 15"
          key={uuidv4()}
          direction="right"
          rankIndex1={2}
          rankIndex2={15}
          data={data?.[6]}
          onBlockClick={onBlockClick}
          isLoading={isLoading}
        ></BracketData>
        <Spacer></Spacer>
      </BracketRound>
    </BracketWrapper>
  );
};
const BracketBlockRightWest = ({ data, isLoading }) => {
  const onBlockClick = () => {
    console.log("111");
  };
  return (
    <BracketWrapper>
      {/* Round 4 */}
      <BracketRound ColumnRound={4} key={uuidv4()}>
        <Spacer></Spacer>
        <BracketData
          key={uuidv4()}
          direction="right"
          data={data?.[14]}
          onBlockClick={onBlockClick}
          isLoading={isLoading}
        ></BracketData>
        <Spacer></Spacer>
      </BracketRound>

      <BracketRound ColumnRound={3} key={uuidv4()}>
        {/* Round 3 */}
        <Spacer></Spacer>
        <BracketData
          teamA="Team 06"
          teamB="Team 11"
          key={uuidv4()}
          direction="right"
          data={data?.[13]}
          onBlockClick={onBlockClick}
          isLoading={isLoading}
        ></BracketData>
        <Spacer></Spacer>
        <BracketData
          teamA="Team 03"
          teamB="Team 14"
          key={uuidv4()}
          direction="right"
          data={data?.[12]}
          onBlockClick={onBlockClick}
          isLoading={isLoading}
        ></BracketData>
        <Spacer></Spacer>
      </BracketRound>

      <BracketRound ColumnRound={2} key={uuidv4()}>
        <Spacer></Spacer>
        <BracketData
          teamA="Team 06"
          teamB="Team 11"
          key={uuidv4()}
          direction="right"
          data={data?.[9]}
          onBlockClick={onBlockClick}
          isLoading={isLoading}
        ></BracketData>
        <Spacer></Spacer>
        <BracketData
          teamA="Team 03"
          teamB="Team 14"
          key={uuidv4()}
          direction="right"
          data={data?.[8]}
          onBlockClick={onBlockClick}
          isLoading={isLoading}
        ></BracketData>
        <Spacer></Spacer>
        <BracketData
          teamA="Team 07"
          teamB="Team 10"
          key={uuidv4()}
          direction="right"
          data={data?.[11]}
          onBlockClick={onBlockClick}
          isLoading={isLoading}
        ></BracketData>
        <Spacer></Spacer>
        <BracketData
          teamA="Team 02"
          teamB="Team 15"
          key={uuidv4()}
          direction="right"
          data={data?.[10]}
          onBlockClick={onBlockClick}
          isLoading={isLoading}
        ></BracketData>
        <Spacer></Spacer>
      </BracketRound>

      <BracketRound ColumnRound={1} key={uuidv4()}>
        <Spacer></Spacer>
        <BracketData
          teamA="Team 01"
          teamB="Team 16"
          key={uuidv4()}
          direction="right"
          rankIndex1={1}
          rankIndex2={16}
          data={data?.[0]}
          onBlockClick={onBlockClick}
          isLoading={isLoading}
        ></BracketData>
        <Spacer></Spacer>
        <BracketData
          teamA="Team 08"
          teamB="Team 09"
          key={uuidv4()}
          direction="right"
          rankIndex1={8}
          rankIndex2={9}
          data={data?.[1]}
          onBlockClick={onBlockClick}
          isLoading={isLoading}
        ></BracketData>
        <Spacer></Spacer>
        <BracketData
          teamA="Team 05"
          teamB="Team 12"
          key={uuidv4()}
          direction="right"
          rankIndex1={5}
          rankIndex2={12}
          data={data?.[2]}
          onBlockClick={onBlockClick}
          isLoading={isLoading}
        ></BracketData>
        <Spacer></Spacer>
        <BracketData
          teamA="Team 04"
          teamB="Team 13"
          key={uuidv4()}
          direction="right"
          rankIndex1={4}
          rankIndex2={13}
          data={data?.[3]}
          onBlockClick={onBlockClick}
          isLoading={isLoading}
        ></BracketData>
        <Spacer></Spacer>
        <BracketData
          teamA="Team 06"
          teamB="Team 11"
          key={uuidv4()}
          direction="right"
          rankIndex1={6}
          rankIndex2={11}
          data={data?.[5]}
          onBlockClick={onBlockClick}
          isLoading={isLoading}
        ></BracketData>
        <Spacer></Spacer>
        <BracketData
          teamA="Team 03"
          teamB="Team 14"
          key={uuidv4()}
          direction="right"
          rankIndex1={3}
          rankIndex2={14}
          data={data?.[4]}
          onBlockClick={onBlockClick}
          isLoading={isLoading}
        ></BracketData>
        <Spacer></Spacer>
        <BracketData
          teamA="Team 07"
          teamB="Team 10"
          key={uuidv4()}
          direction="right"
          rankIndex1={7}
          rankIndex2={10}
          data={data?.[7]}
          onBlockClick={onBlockClick}
          isLoading={isLoading}
        ></BracketData>
        <Spacer></Spacer>
        <BracketData
          teamA="Team 02"
          teamB="Team 15"
          key={uuidv4()}
          direction="right"
          rankIndex1={2}
          rankIndex2={15}
          data={data?.[6]}
          onBlockClick={onBlockClick}
          isLoading={isLoading}
        ></BracketData>
        <Spacer></Spacer>
      </BracketRound>
    </BracketWrapper>
  );
};

const Spacer = () => {
  return <li className="spacer">&nbsp;</li>;
};

const FinalFourBlock = ({ data }) => {
  const [showModalOnClick, setModalClick] = useState(false);

  const handleModalClick = () => {
    setModalClick(true);
  };

  return (
    <Fragment>
      <div className="FinalFourBlock" onClick={handleModalClick}>
        <p className="top">
          {data?.["Winner"]}
          {/* <img src={`/static/media/logos/${data?.["Winner"]}.png`} /> */}
          {getImage(data?.["Winner"])}
        </p>

        <p className="bottom">
          {data?.["Winner"] === data?.["Team 1"] ? data?.["Team 2"] : data?.["Team 1"]}
          {/* <img
            src={`/static/media/logos/${
              data?.["Winner"] === data?.["Team 1"] ? data?.["Team 2"] : data?.["Team 1"]
            }.png`}
          /> */}
          {getImage(data?.["Winner"] === data?.["Team 1"] ? data?.["Team 2"] : data?.["Team 1"])}
        </p>
      </div>
    </Fragment>
  );
};

const Bracket = ({ data = [], render = undefined }) => {
  const [region1, setRegion1] = useState([]);
  const [region2, setRegion2] = useState([]);
  const [region3, setRegion3] = useState([]);
  const [region4, setRegion4] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const onBlockClick = () => {
    console.log("111");
  };
  useEffect(() => {
    if (data.length > 0) {
      // setRegion1(data.slice(0, 15));
      // setRegion2(data.slice(15, 30));
      // setRegion3(data.slice(30, 45));
      // setRegion4(data.slice(45, 60));
      // setRegion1(data.filter((dt) => dt.Region === "E"));
      // setRegion2(data.filter((dt) => dt.Region === "MW"));
      // setRegion3(data.filter((dt) => dt.Region === "W"));
      // setRegion4(data.filter((dt) => dt.Region === "S"));
      setRegion1(data.filter((dt) => dt.Region === "S"));
      setRegion2(data.filter((dt) => dt.Region === "E"));
      setRegion3(data.filter((dt) => dt.Region === "W"));
      setRegion4(data.filter((dt) => dt.Region === "MW"));
      setIsLoading(false);
    }
  }, [data]);

  return (
    <section style={{ backgroundColor: "#f2f4f6" }}>
      <div className="container BracketWrapper">
        <div className="row">
          <div className="col-sm-12 mt-3 mb-3">
            <div className="championship">
              <h1 className="text-center text-uppercase ">Winner: {data?.[62]?.["Winner"]}</h1>

              <div className="col-sm-12 text-center">
                {/* <img src={`/static/media/logos/${data?.[62]?.["Winner"]}.png`} /> */}
                {getImage(data?.[62]?.["Winner"], true)}
              </div>
            </div>
          </div>
        </div>
        <div className="row no-gutter">
          <div className="col-sm-5">
            <div className="row">
              <div className="col-sm-12">
                <h2 className="text-left">South</h2>
                <BracketBlockLeft
                  direction="left"
                  data={region1}
                  onBlockClick={onBlockClick}
                  isLoading={isLoading}
                ></BracketBlockLeft>
              </div>
              <div className="col-sm-12">
                <h2 className="text-left">West</h2>
                <BracketBlockLeft
                  direction="left"
                  data={region3}
                  onBlockClick={onBlockClick}
                  isLoading={isLoading}
                ></BracketBlockLeft>
              </div>
            </div>
          </div>
          <div className="col-sm-2 d-flex finalFourColumnWrapper">
            <div className="finalFour m-auto text-center">
              <div>
                <h2>Final Four</h2>
                <span className="finalFour--location">
                  {/* Indianapolis, IN
                  <br />
                  Sat April 3 */}
                </span>

                <FinalFourBlock data={data?.[60]} onBlockClick={onBlockClick} />
                <FinalFourBlock data={data?.[61]} onBlockClick={onBlockClick} />
              </div>

              <div>
                <h2>NCAA Champion</h2>
                {/* <span className="finalFour--location">Mon April 5</span> */}
                <FinalFourBlock data={data?.[62]} onBlockClick={onBlockClick} />
              </div>
            </div>
          </div>
          <div className="col-sm-5">
            <div className="row">
              <div className="col-sm-12">
                <h2 className="text-right">East</h2>
                <BracketBlockRight
                  direction="right"
                  data={region2}
                  onBlockClick={onBlockClick}
                  isLoading={isLoading}
                ></BracketBlockRight>
              </div>
              <div className="col-sm-12">
                <h2 className="text-right">Midwest</h2>
                <BracketBlockRightWest
                  direction="right"
                  data={region4}
                  onBlockClick={onBlockClick}
                  isLoading={isLoading}
                ></BracketBlockRightWest>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Bracket;
